import type { QueryGroupPatternType } from "@amethyst/ai-tools";

export {
  type QueryGroupPatternType,
  queryGroupPatternTypeEnum,
} from "@amethyst/ai-tools";

import { msg } from "@lingui/core/macro";

// Search Analytics 用 QueryGroupPatternType の共通定義とラベル

export const QueryGroupPatternTypeLabels: Record<
  QueryGroupPatternType,
  ReturnType<typeof msg>
> = {
  INCLUDES: msg`Contains`,
  STARTS_WITH: msg`Starts with`,
  ENDS_WITH: msg`Ends with`,
  EQUALS: msg`Equals`,
  REGEX: msg`Regex`,
  NOT_INCLUDES: msg`Does not contain`,
  CONTAINS: msg`Contains`,
  NOT_CONTAINS: msg`Does not contain`,
  NOT_REGEX: msg`Does not match regex`,
};
